export const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? 'https://japl-backend-v2jm.onrender.com/api' 
  : 'http://localhost:5000/api';
